module.exports = __webpack_public_path__ + "static/process-diagram-step1-equation-dd115bbd8eb3ff179ad39bd64f988457.png";